import type { Accessor, JSX } from "solid-js"
import { Masonry } from "@/designSystem/components/masonry/masonry"
import { Note, NoteFragment } from "@/designSystem/patterns/note"
import { graphql, type ResultOf } from "@/graphql"

export const MasonryNoteFragment = graphql(
  `fragment MasonryNoteFragment on Note {
    id
    ...NoteFragment
  }`,
  [NoteFragment],
)

type NoteItem = ResultOf<typeof MasonryNoteFragment>

interface MasonrySectionProps {
  items: Accessor<NoteItem[]>
  showDelete?: boolean
  onDelete?: (noteId: string) => void
  maxNoteContentHeight?: number
  editingNoteId?: Accessor<string | null>
  onNoteClick?: (noteId: string) => void
  onCopyToPost?: (noteContent: string) => void
}

export function MasonrySection(props: MasonrySectionProps): JSX.Element {
  return (
    <Masonry
      items={props.items}
      columns={{ xxl: 1 }}
      renderItem={(item: NoteItem) => {
        return (
          <Note
            note={item}
            interactive={
              !props.editingNoteId || props.editingNoteId() !== item.id
            }
            editable={props.editingNoteId?.() === item.id}
            onClick={() => props.onNoteClick?.(item.id)}
            showDelete={props.showDelete}
            onDelete={() => props.onDelete?.(item.id)}
            maxContentHeight={props.maxNoteContentHeight}
            onCopyToPost={props.onCopyToPost}
          />
        )
      }}
    />
  )
}
